import int01 from "./Introduccion/Intro-01.mp3";
import int02 from "./Introduccion/Intro-02.mp3";
import int03 from "./Introduccion/Intro-03.mp3";

import sub1_act1_a01 from "./Subtema_1/T1-Sub 1- Act 1-A01.mp3";
import sub1_act1_a02 from "./Subtema_1/T1-Sub 1- Act 1-A02.mp3";
import sub1_act2_a01 from "./Subtema_1/T1-Sub 1- Act 2-A01.mp3";
import sub1_act3_a01 from "./Subtema_1/T1-Sub 1- Act 3-A01.mp3";
import sub1_act3_a02 from "./Subtema_1/T1-Sub 1- Act 3-A02.mp3";
import sub1_act3_a03 from "./Subtema_1/T1-Sub 1- Act 3-A03.mp3";
import sub1_act3_a04 from "./Subtema_1/T1-Sub 1- Act 3-A04.mp3";
import sub1_act4_a01 from "./Subtema_1/T1-Sub 1- Act 4-A01.mp3";
import sub1_act5_a01 from "./Subtema_1/T1-Sub 1- Act 5-A01.mp3";
import sub1_act5_a02 from "./Subtema_1/T1-Sub 1- Act 5-A02.mp3";
import sub1_act5_a03 from "./Subtema_1/T1-Sub 1- Act 5-A03.mp3";
import sub1_act5_a04 from "./Subtema_1/T1-Sub 1- Act 5-A04.mp3";
import sub1_act5_a05 from "./Subtema_1/T1-Sub 1- Act 5-A05.mp3";
import sub1_act5_a06 from "./Subtema_1/T1-Sub 1- Act 5-A06.mp3";
import sub1_act5_a07 from "./Subtema_1/T1-Sub 1- Act 5-A07.mp3";
import sub1_act5_a08 from "./Subtema_1/T1-Sub 1- Act 5-A08.mp3";
import sub1_act5_a09 from "./Subtema_1/T1-Sub 1- Act 5-A09.mp3";
import sub1_act5_a10 from "./Subtema_1/T1-Sub 1- Act 5-A10.mp3";

import sub2_act1_a01 from "./Subtema_2/T1-Sub 2- Act 1-A01.mp3";
import sub2_act1_a02 from "./Subtema_2/T1-Sub 2- Act 1-A02.mp3";
import sub2_act1_a03 from "./Subtema_2/T1-Sub 2- Act 1-A03.mp3";
import sub2_act2_a01 from "./Subtema_2/T1-Sub 2- Act 2-A01.mp3";
import sub2_act2_a02 from "./Subtema_2/T1-Sub 2- Act 2-A02.mp3";
import sub2_act2_a03 from "./Subtema_2/T1-Sub 2- Act 2-A03.mp3";
import sub2_act2_a04 from "./Subtema_2/T1-Sub 2- Act 2-A04.mp3";
import sub2_act2_a05 from "./Subtema_2/T1-Sub 2- Act 2-A05.mp3";
import sub2_act2_a06 from "./Subtema_2/T1-Sub 2- Act 2-A06.mp3";
import sub2_act2_a07 from "./Subtema_2/T1-Sub 2- Act 2-A07.mp3";
import sub2_act3_a01 from "./Subtema_2/T1-Sub 2- Act 3-A01.mp3";
import sub2_act3_a02 from "./Subtema_2/T1-Sub 2- Act 3-A02.mp3";
import sub2_act3_a03 from "./Subtema_2/T1-Sub 2- Act 3-A03.mp3";
import sub2_act3_a04 from "./Subtema_2/T1-Sub 2- Act 3-A04.mp3";
import sub2_act3_a05 from "./Subtema_2/T1-Sub 2- Act 3-A05.mp3";
import sub2_act3_a06 from "./Subtema_2/T1-Sub 2- Act 3-A06.mp3";
import sub2_act3_a07 from "./Subtema_2/T1-Sub 2- Act 3-A07.mp3";

import sub3_act1_a01 from "./Subtema_3/T1-Sub 3- Act 1-A01.mp3";
import sub3_act1_a02 from "./Subtema_3/T1-Sub 3- Act 1-A02.mp3";
import sub3_act1_a03 from "./Subtema_3/T1-Sub 3- Act 1-A03.mp3";
import sub3_act1_a04 from "./Subtema_3/T1-Sub 3- Act 1-A04.mp3";
import sub3_act1_a05 from "./Subtema_3/T1-Sub 3- Act 1-A05.mp3";
import sub3_act1_a06 from "./Subtema_3/T1-Sub 3- Act 1-A06.mp3";
import sub3_act1_a07 from "./Subtema_3/T1-Sub 3- Act 1-A07.mp3";
import sub3_act1_a08 from "./Subtema_3/T1-Sub 3- Act 1-A08.mp3";
import sub3_act1_a09 from "./Subtema_3/T1-Sub 3- Act 1-A09.mp3";
import sub3_act1_a10 from "./Subtema_3/T1-Sub 3- Act 1-A10.mp3";
import sub3_act1_a11 from "./Subtema_3/T1-Sub 3- Act 1-A11.mp3";
import sub3_act1_a12 from "./Subtema_3/T1-Sub 3- Act 1-A12.mp3";
import sub3_act2_a01 from "./Subtema_3/T1-Sub 3- Act 2-A01.mp3";
import sub3_act2_a02 from "./Subtema_3/T1-Sub 3- Act 2-A02.mp3";

import sub4_act1_a01 from "./Subtema_4/T1-Sub 4- Act 1-A01.mp3";
import sub4_act1_a02 from "./Subtema_4/T1-Sub 4- Act 1-A02.mp3";
import sub4_act1_a03 from "./Subtema_4/T1-Sub 4- Act 1-A03.mp3";
import sub4_act1_a04 from "./Subtema_4/T1-Sub 4- Act 1-A04.mp3";
import sub4_act1_a05 from "./Subtema_4/T1-Sub 4- Act 1-A05.mp3";
import sub4_act1_a06 from "./Subtema_4/T1-Sub 4- Act 1-A06.mp3";
import sub4_act1_a07 from "./Subtema_4/T1-Sub 4- Act 1-A07.mp3";
import sub4_act1_a08 from "./Subtema_4/T1-Sub 4- Act 1-A08.mp3";
import sub4_act1_a09 from "./Subtema_4/T1-Sub 4- Act 1-A09.mp3";
import sub4_act1_a10 from "./Subtema_4/T1-Sub 4- Act 1-A10.mp3";
import sub4_act2_a01 from "./Subtema_4/T1-Sub 4- Act 2-A01.mp3";
import sub4_act2_a02 from "./Subtema_4/T1-Sub 4- Act 2-A02.mp3";
import sub4_act2_a03 from "./Subtema_4/T1-Sub 4- Act 2-A03.mp3";
import sub4_act2_a04 from "./Subtema_4/T1-Sub 4- Act 2-A04.mp3";
import sub4_act2_a05 from "./Subtema_4/T1-Sub 4- Act 2-A05.mp3";
import sub4_act2_a06 from "./Subtema_4/T1-Sub 4- Act 2-A06.mp3";
import sub4_act2_a07 from "./Subtema_4/T1-Sub 4- Act 2-A07.mp3";
import sub4_act2_a08 from "./Subtema_4/T1-Sub 4- Act 2-A08.mp3";
import sub4_act2_a09 from "./Subtema_4/T1-Sub 4- Act 2-A09.mp3";


import sub5_act1_a01 from "./Subtema_5/T1-Sub 5- Act 1-A01.mp3";
import sub5_act1_a02 from "./Subtema_5/T1-Sub 5- Act 1-A02.mp3";
import sub5_act1_a03 from "./Subtema_5/T1-Sub 5- Act 1-A03.mp3";
import sub5_act1_a04 from "./Subtema_5/T1-Sub 5- Act 1-A04.mp3";
import sub5_act1_a05 from "./Subtema_5/T1-Sub 5- Act 1-A05.mp3";
import sub5_act1_a06 from "./Subtema_5/T1-Sub 5- Act 1-A06.mp3";
import sub5_act1_a07 from "./Subtema_5/T1-Sub 5- Act 1-A07.mp3";
import sub5_act1_a08 from "./Subtema_5/T1-Sub 5- Act 1-A08.mp3";
import sub5_act1_a09 from "./Subtema_5/T1-Sub 5- Act 1-A09.mp3";
import sub5_act1_a10 from "./Subtema_5/T1-Sub 5- Act 1-A10.mp3";

import sub6_act1_a01 from "./Subtema_6/T1-Sub 6- Act 1-A01.mp3";
import sub6_act1_a02 from "./Subtema_6/T1-Sub 6- Act 1-A02.mp3";
import sub6_act1_a03 from "./Subtema_6/T1-Sub 6- Act 1-A03.mp3";
import sub6_act1_a04 from "./Subtema_6/T1-Sub 6- Act 1-A04.mp3";
import sub6_act1_a05 from "./Subtema_6/T1-Sub 6- Act 1-A05.mp3";
import sub6_act1_a06 from "./Subtema_6/T1-Sub 6- Act 1-A06.mp3";
import sub6_act1_a07 from "./Subtema_6/T1-Sub 6- Act 1-A07.mp3";
import sub6_act1_a08 from "./Subtema_6/T1-Sub 6- Act 1-A08.mp3";

import sub7_act1_a01 from "./Subtema_7/T1-Sub 7- Act 1-A01.mp3";
import sub7_act1_a02 from "./Subtema_7/T1-Sub 7- Act 1-A02.mp3";
import sub7_act1_a03 from "./Subtema_7/T1-Sub 7- Act 1-A03.mp3";
import sub7_act1_a04 from "./Subtema_7/T1-Sub 7- Act 1-A04.mp3";
import sub7_act1_a05 from "./Subtema_7/T1-Sub 7- Act 1-A05.mp3";
import sub7_act1_a06 from "./Subtema_7/T1-Sub 7- Act 1-A06.mp3";
import sub7_act1_a07 from "./Subtema_7/T1-Sub 7- Act 1-A07.mp3";
import sub7_act1_a08 from "./Subtema_7/T1-Sub 7- Act 1-A08.mp3";
import sub7_act2_a01 from "./Subtema_7/T1-Sub 7- Act 2-A01.mp3";
import sub7_act2_a02 from "./Subtema_7/T1-Sub 7- Act 2-A02.mp3";
import sub7_act2_a03 from "./Subtema_7/T1-Sub 7- Act 2-A03.mp3";
import sub7_act2_a04 from "./Subtema_7/T1-Sub 7- Act 2-A04.mp3";
import sub7_act2_a05 from "./Subtema_7/T1-Sub 7- Act 2-A05.mp3";
import sub7_act2_a06 from "./Subtema_7/T1-Sub 7- Act 2-A06.mp3";
import sub7_act2_a07 from "./Subtema_7/T1-Sub 7- Act 2-A07.mp3";
import sub7_act2_a08 from "./Subtema_7/T1-Sub 7- Act 2-A08.mp3";
import sub7_act2_a09 from "./Subtema_7/T1-Sub 7- Act 2-A09.mp3";
import sub7_act2_a10 from "./Subtema_7/T1-Sub 7- Act 2-A10.mp3";
import sub7_act2_a11 from "./Subtema_7/T1-Sub 7- Act 2-A11.mp3";
import sub7_act2_a12 from "./Subtema_7/T1-Sub 7- Act 2-A12.mp3";


// ... (las importaciones anteriores)

export const T1_voices = {
	introduccion: {
		int01,
		int02,
		int03,
	},
	sub01: {
		sub1_act1_a01,
		sub1_act1_a02,
		sub1_act2_a01,
		sub1_act3_a01,
		sub1_act3_a02,
		sub1_act3_a03,
		sub1_act3_a04,
		sub1_act4_a01,
		sub1_act5_a01,
		sub1_act5_a02,
		sub1_act5_a03,
		sub1_act5_a04,
		sub1_act5_a05,
		sub1_act5_a06,
		sub1_act5_a07,
		sub1_act5_a08,
		sub1_act5_a09,
		sub1_act5_a10,
	},
	sub02: {
		sub2_act1_a01,
		sub2_act1_a02,
		sub2_act1_a03,
		sub2_act2_a01,
		sub2_act2_a02,
		sub2_act2_a03,
		sub2_act2_a04,
		sub2_act2_a05,
		sub2_act2_a06,
		sub2_act2_a07,
		sub2_act3_a01,
		sub2_act3_a02,
		sub2_act3_a03,
		sub2_act3_a04,
		sub2_act3_a05,
		sub2_act3_a06,
		sub2_act3_a07,
	},
	sub03: {
		sub3_act1_a01,
		sub3_act1_a02,
		sub3_act1_a03,
		sub3_act1_a04,
		sub3_act1_a05,
		sub3_act1_a06,
		sub3_act1_a07,
		sub3_act1_a08,
		sub3_act1_a09,
		sub3_act1_a10,
		sub3_act1_a11,
		sub3_act1_a12,
		sub3_act2_a01,
		sub3_act2_a02,
	},
	sub04: {
		sub4_act1_a01,
		sub4_act1_a02,
		sub4_act1_a03,
		sub4_act1_a04,
		sub4_act1_a05,
		sub4_act1_a06,
		sub4_act1_a07,
		sub4_act1_a08,
		sub4_act1_a09,
		sub4_act1_a10,
		sub4_act2_a01,
		sub4_act2_a02,
		sub4_act2_a03,
		sub4_act2_a04,
		sub4_act2_a05,
		sub4_act2_a06,
		sub4_act2_a07,
		sub4_act2_a08,
		sub4_act2_a09,
	},
	sub05: {
		sub5_act1_a01,
		sub5_act1_a02,
		sub5_act1_a03,
		sub5_act1_a04,
		sub5_act1_a05,
		sub5_act1_a06,
		sub5_act1_a07,
		sub5_act1_a08,
		sub5_act1_a09,
		sub5_act1_a10,
	},
	sub06: {
		sub6_act1_a01,
		sub6_act1_a02,
		sub6_act1_a03,
		sub6_act1_a04,
		sub6_act1_a05,
		sub6_act1_a06,
		sub6_act1_a07,
		sub6_act1_a08,
	},
	sub07: {
		sub7_act1_a01,
		sub7_act1_a02,
		sub7_act1_a03,
		sub7_act1_a04,
		sub7_act1_a05,
		sub7_act1_a06,
		sub7_act1_a07,
		sub7_act1_a08,
		sub7_act2_a01,
		sub7_act2_a02,
		sub7_act2_a03,
		sub7_act2_a04,
		sub7_act2_a05,
		sub7_act2_a06,
		sub7_act2_a07,
		sub7_act2_a08,
		sub7_act2_a09,
		sub7_act2_a10,
		sub7_act2_a11,
		sub7_act2_a12,
	},
};
